import React, { useState } from "react";
import { Checkbox, Select, message, Collapse, Button } from "antd";
import { postRequest } from "../service/index";
import { CaretRightOutlined } from '@ant-design/icons';
import { Crown, UserRound, Calculator, Building2, Users, Clock, CalendarDays } from "lucide-react";

const Designation = ({ onClose, onSuccess }) =>  {
  
  const [loading, setLoading] = useState(false);
  const [designationName, setDesignationName] = useState("");
  const [customRoleName, setCustomRoleName] = useState("");
  const [selectedRole, setSelectedRole] = useState(null);
  const [permissions, setPermissions] = useState({
    Organization: {
      Assest: { all: false, view: false, add: false, edit: false, delete: false },
      // 'Employee Group': { all: false, view: false, add: false, edit: false, delete: false },
      Events: { all: false, view: false, add: false, edit: false, delete: false },
      Department: { all: false, view: false, add: false, edit: false, delete: false },
      'Work Location': { all: false, view: false, add: false, edit: false, delete: false },
      Designation: { all: false, view: false, add: false, edit: false, delete: false },
      Inventory: { all: false, view: false, add: false, edit: false, delete: false},
    },
    Employee: {
      Recruitment: { all: false, view: false, add: false, edit: false, delete: false },
      'All Employee Access': { all: false, view: false, add: false, edit: false, export: false },
      Offboarding: { all: false, view: false, add: false, edit: false, delete: false },
      Resignation: { all: false, view: false, add: false, edit: false, delete: false },
    },
    Attendance: {
      'Attendance Details': { all: false, view: false, add: false, edit: false, delete: false },
      'Overtime Policy': { all: false, view: false, add: false, edit: false, delete: false },
      'Overtime Request': { all: false, view: false, add: false, edit: false, delete: false },
      'Attendance Request': { all: false, view: false, add: false, edit: false, delete: false },
      'Shift Time': { all: false, view: false, add: false, edit: false, delete: false },
      'Attendance Setting': { all: false, view: false, add: false, edit: false, delete: false },
    },
    Leaves: {
      'Leaves Request': { all: false, view: false, add: false, edit: false, delete: false },
      'Public Holiday': { all: false, view: false, add: false, edit: false, delete: false },
      'Add Leaves': { all: false, view: false, add: false, edit: false, delete: false },
      'Leave Setting' : { all: false, view: false, add: false, edit: false, delete: false },
    },
    Payroll: {
      'Run Payroll': { all: false, view: false, add: false, edit: false, delete: false },
      'Monthly Inputs': { all: false, view: false, add: false, edit: false, delete: false },
      'Monthly Payroll': { all: false, view: false, edit: false, delete: false, process: false, approve: false },
      'Loan and Payment': { all: false, view: false, add: false, edit: false, delete: false },
      'Request Loan': { all: false, view: false, add: false, edit: false, delete: false },
      'Compensation Info': { all: false, view: false, add: false, edit: false, delete: false },
      'Settings': { all: false, view: false, add: false, edit: false, delete: false },
    },
  });

  const roleOptions = [
    { value: 'admin', label: 'Admin' },
    { value: 'manager', label: 'Manager' },
    { value: 'employee', label: 'Employee' },
    { value: 'custom', label: 'Custom' }
  ];

  // Use lucide-react icons for modules
  const moduleIcons = {
    admin: <Crown className="w-5 h-5 text-yellow-500" />,
    employee: <UserRound className="w-5 h-5 text-blue-500" />,
    payroll: <Calculator className="w-5 h-5 text-green-500" />,
  };

  // Main module icons
  const mainModuleIcons = {
    Organization: <Building2 className="w-5 h-5 text-purple-600" />,
    Employee: <Users className="w-5 h-5 text-blue-600" />,
    Attendance: <Clock className="w-5 h-5 text-orange-500" />,
    Leaves: <CalendarDays className="w-5 h-5 text-green-600" />,
    Payroll: <Calculator className="w-5 h-5 text-green-500" />,
  };

  const handleAllChange = (mainModule, subModule) => (e) => {
    const checked = e.target.checked;
    setPermissions(prev => ({
      ...prev,
      [mainModule]: {
        ...prev[mainModule],
        [subModule]: (
          subModule === 'Monthly Payroll'
            ? { all: checked, view: checked, edit: checked, delete: checked, process: checked, approve: checked }
            : subModule === 'Inventory'
              ? { all: checked, view: checked, add: checked, edit: checked, delete: checked }
              : subModule === 'All Employee Access'
                ? { all: checked, view: checked, add: checked, edit: checked, export: checked }
                : { all: checked, view: checked, add: checked, edit: checked, delete: checked }
        )
      }
    }));
  };

  const handlePermissionChange = (mainModule, subModule, permission) => (e) => {
    const checked = e.target.checked;
    setPermissions(prev => {
      const updated = {
        ...prev,
        [mainModule]: {
          ...prev[mainModule],
          [subModule]: {
            ...prev[mainModule][subModule],
            [permission]: checked,
          }
        }
      };
      // If all individual permissions are checked, set 'all' to true
      const perms = updated[mainModule][subModule];
      if (subModule === 'Monthly Payroll') {
        updated[mainModule][subModule].all =
          !!(perms.view && perms.edit && perms.delete && perms.process && perms.approve);
      } else if (subModule === 'Inventory') {
        updated[mainModule][subModule].all = !!(perms.view && perms.add && perms.edit && perms.delete);
      } else if (subModule === 'All Employee Access') {
        updated[mainModule][subModule].all = !!(perms.view && perms.add && perms.edit && perms.export);
      } else {
        updated[mainModule][subModule].all =
          !!(perms.view && perms.add && perms.edit && perms.delete);
      }
      // If 'all' is checked, check all others
      if (permission === 'all' && checked) {
        updated[mainModule][subModule] = subModule === 'Monthly Payroll'
          ? { all: true, view: true, edit: true, delete: true, process: true, approve: true }
          : subModule === 'Inventory'
            ? { all: true, view: true, add: true, edit: true, delete: true }
            : subModule === 'All Employee Access'
              ? { all: true, view: true, add: true, edit: true, export: true }
              : { all: true, view: true, add: true, edit: true, delete: true };
      }
      return updated;
    });
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (!designationName || !selectedRole) {
      message.error('Please fill in all required fields');
      setLoading(false);
      return;
    }

    // Validate custom role name if custom role is selected
    if (selectedRole === 'custom' && !customRoleName.trim()) {
      message.error('Please enter a custom role name');
      setLoading(false);
      return;
    }

    // Convert permissions object to the required format
    const formattedPermissions = {};
    for (const [mainModule, subModules] of Object.entries(permissions)) {
      formattedPermissions[mainModule] = {};
      for (const [subModule, perms] of Object.entries(subModules)) {
        const basePerms = subModule === 'Monthly Payroll'
          ? ['view', 'edit', 'delete', 'process', 'approve']
          : subModule === 'Inventory'
            ? ['view', 'add', 'edit', 'delete']
            : subModule === 'All Employee Access'
              ? ['view', 'add', 'edit', 'export']
              : ['view', 'add', 'edit', 'delete'];
        const checkedPerms = basePerms.filter(p => perms[p]);
        formattedPermissions[mainModule][subModule] = checkedPerms;
      }
    }

    const payload = {
      designationName,
      role: selectedRole === 'custom' ? customRoleName : selectedRole,
      permissions: selectedRole === 'employee' ? {} : formattedPermissions
    };
    try {
      const response = await postRequest('/api/companies/designation', payload);
      if (response.message === "Designation created successfully") {
        message.success('Designation created successfully');
        onSuccess && onSuccess();
        onClose();
      }
      else{
        message.error(response.error || "Designation Not created")
        setLoading(false);
      }
    } catch (error) {
      console.error('Error creating designation:', error);
      message.error('Failed to create designation. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col gap-3 max-h-[80vh] overflow-y-auto">
      <div className="flex flex-col gap-1">
        <label htmlFor="designation-name" className="text-md">
          Designation Name
        </label>
        <input
          type="text"
          id="designation-name"
          className="border border-gray-400 outline-hidden px-2 py-1 rounded-md text-md"
          placeholder="designation name"
          value={designationName}
          onChange={(e) => setDesignationName(e.target.value)}
        />
      </div>

      <div className="flex flex-col gap-1">
        <label htmlFor="role" className="text-md">
          Role
        </label>
        <Select
          id="role"
          options={roleOptions}
          value={selectedRole}
          onChange={setSelectedRole}
          placeholder="Select a role"
          className="w-full"
        />
      </div>

      {selectedRole === 'custom' && (
        <div className="flex flex-col gap-1">
          <label htmlFor="custom-role-name" className="text-md">
            Custom Role Name
          </label>
          <input
            type="text"
            id="custom-role-name"
            className="border border-gray-400 outline-hidden px-2 py-1 rounded-md text-md"
            placeholder="Enter custom role name"
            value={customRoleName}
            onChange={(e) => setCustomRoleName(e.target.value)}
          />
        </div>
      )}

      {selectedRole !== 'employee' && (
        <div className="mt-4">
          <Collapse
            accordion
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
          >
            {Object.entries(permissions).map(([mainModule, subModules]) => (
              <Collapse.Panel
                header={
                  <div className="flex items-center gap-2">
                    <span>{mainModuleIcons[mainModule]}</span>
                    <span className="capitalize font-medium">{mainModule}</span>
                  </div>
                }
                key={mainModule}
              >
                {Object.entries(subModules).map(([subModule, perms]) => (
                  <div key={subModule} className="mb-4">
                    <div className={`grid ${subModule === 'Monthly Payroll' ? 'grid-cols-8' : 'grid-cols-6'} gap-2 mb-2 text-md font-medium`}>
                      <div className="col-span-1 capitalize">{subModule}</div>
                      <div className="col-span-1 text-center">All</div>
                      <div className="col-span-1 text-center">View</div>
                      {subModule !== 'Monthly Payroll' && (
                        <div className="col-span-1 text-center">Add</div>
                      )}
                      <div className="col-span-1 text-center">Edit</div>
                      <div className="col-span-1 text-center">{subModule === 'All Employee Access' ? 'Export' : 'Delete'}</div>
                      {subModule === 'Monthly Payroll' && (
                        <>
                          <div className="col-span-1 text-center">Process</div>
                          <div className="col-span-1 text-center">Approve</div>
                        </>
                      )}
                    </div>
                    <div className={`grid ${subModule === 'Monthly Payroll' ? 'grid-cols-8' : 'grid-cols-6'} gap-2 mb-2`}>
                      <div className="col-span-1 capitalize"></div>
                      <div className="col-span-1 text-center">
                        <Checkbox checked={perms.all} onChange={handleAllChange(mainModule, subModule)} />
                      </div>
                      <div className="col-span-1 text-center">
                        <Checkbox checked={perms.view} onChange={handlePermissionChange(mainModule, subModule, 'view')} />
                      </div>
                      {subModule !== 'Monthly Payroll' && (
                        <div className="col-span-1 text-center">
                          <Checkbox checked={perms.add} onChange={handlePermissionChange(mainModule, subModule, 'add')} />
                        </div>
                      )}
                      <div className="col-span-1 text-center">
                        <Checkbox checked={perms.edit} onChange={handlePermissionChange(mainModule, subModule, 'edit')} />
                      </div>
                      <div className="col-span-1 text-center">
                        {subModule === 'All Employee Access' ? (
                          <Checkbox checked={perms.export} onChange={handlePermissionChange(mainModule, subModule, 'export')} />
                        ) : (
                          <Checkbox checked={perms.delete} onChange={handlePermissionChange(mainModule, subModule, 'delete')} />
                        )}
                      </div>
                      {subModule === 'Monthly Payroll' && (
                        <>
                          <div className="col-span-1 text-center">
                            <Checkbox checked={perms.process} onChange={handlePermissionChange(mainModule, subModule, 'process')} />
                          </div>
                          <div className="col-span-1 text-center">
                            <Checkbox checked={perms.approve} onChange={handlePermissionChange(mainModule, subModule, 'approve')} />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                ))}
              </Collapse.Panel>
            ))}
          </Collapse>
        </div>
      )}

      {selectedRole === 'employee' && (
        <div className="mt-4 p-4 bg-gray-50 rounded-md">
          <p className="text-gray-600 text-center">
            Employee role has no permissions to configure. All permissions are automatically set to none.
          </p>
        </div>
      )}

      <div className="flex justify-end gap-2 mt-4">
          <Button onClick={onClose}>Cancel</Button>
          <Button 
            type="primary" 
            onClick={handleSubmit}
            loading={loading}
            className="bg-primary hover:bg-primary/80"
          >
             {loading ? "Creating..." : "Create Designation"}
          </Button>
        </div>
    </div>
  );
};

export default Designation;
